import { UserStatus } from '../../models/enums/user-status.enum';
import { User } from '../../models/interfaces/user.interface';
import { userMock } from './user.mock';

const TENANT_ID = 'tenant-uuid';
const TENANT_NAME = 'Tenant Teste';

export const studentTestUser = {
  id: '1c41afca-e637-4d9f-8cd1-2b3f3302f80d',
  name: 'Aluno Teste',
  email: 'user@unico.com',
  password: '123456',
};

export const meMock: User = {
  id: studentTestUser.id,
  tenantId: TENANT_ID,
  tenantName: TENANT_NAME,
  email: studentTestUser.email,
  name: studentTestUser.name,
  status: UserStatus.ACTIVE,
  isAdmin: false,
  roles: ['app:*'],
  context: 'app',
  createdAt: new Date(),
  updatedAt: new Date(),
  isActive: true,
};

export function toUserFromMock(email?: string | null): User {
  const normalized = email?.trim().toLowerCase();

  if (normalized === studentTestUser.email.toLowerCase()) {
    return { ...meMock };
  }

  const matched = normalized
    ? userMock.find(user =>
      user.email.toLowerCase() === normalized
      || user.email.toLowerCase().startsWith(normalized)
      || user.name.toLowerCase() === normalized)
    : undefined;

  const source = matched ?? meMock;

  return {
    ...source,
    roles: resolveMockUserRoles(source),
    context: source.context ?? (source.isAdmin ? 'admin' : 'app'),
  };
}

function resolveMockUserRoles(user: Pick<User, 'roles' | 'isAdmin'>): string[] {
  if (user.roles?.length) {
    return user.roles;
  }

  return user.isAdmin ? ['admin:*'] : ['app:*'];
}

export function isValidMockCredentials(email: string | null, password: string | null): boolean {
  return email?.trim().toLowerCase() === studentTestUser.email.toLowerCase()
    && password === studentTestUser.password;
}
